import AuscultationRecording from 'pages/Auscultation/AuscultationRecording';

export default function LungAuscultation() {
  return <AuscultationRecording type="lungs" />;
}
